import React from "react";
import Grid from "@mui/material/Grid";
import {
  CheckboxGroup,
  HandleError,
  Textarea,
  RadioGroup,
  TextField,
  CheckboxSingle,
} from "../form";
import FormRow from "../FormRow";
import {
  ADDITIONAL_PETS,
  APPLIANCES,
  LAUNDRY,
  PARKING,
  SECURITY,
  UTILITIES_SERVICES,
  MAINTENANCE,
} from "../../constants";

function FormProperty({ suffix }) {
  let defaultSuffix = "";
  if (suffix) {
    defaultSuffix = `${suffix}.`;
  }
  return (
    <>
      <FormRow label="Address">
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <TextField
              label="Street"
              name={`${defaultSuffix}address.street`}
              InputLabelProps={{
                shrink: true,
              }}
              variant="standard"
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              label="City"
              name={`${defaultSuffix}address.city`}
              InputLabelProps={{
                shrink: true,
              }}
              variant="standard"
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              label="State"
              name={`${defaultSuffix}address.subdivision`}
              disabled
              InputLabelProps={{
                shrink: true,
              }}
              variant="standard"
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              label="Zip Code"
              name={`${defaultSuffix}address.postalCode`}
              InputLabelProps={{
                shrink: true,
              }}
              variant="standard"
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              label="Country"
              name={`${defaultSuffix}address.country`}
              disabled
              InputLabelProps={{
                shrink: true,
              }}
              variant="standard"
            />
          </Grid>
        </Grid>
      </FormRow>
      <FormRow label="Additional Pets">
        <RadioGroup
          list={ADDITIONAL_PETS}
          name={`${defaultSuffix}additionalPetsInBuilding`}
        />
        <HandleError name={`${defaultSuffix}additionalPetsInBuilding`} />
      </FormRow>

      <FormRow label="Appliances">
        <CheckboxGroup list={APPLIANCES} name={`${defaultSuffix}appliances`} />
      </FormRow>

      <FormRow label="Laundry">
        <RadioGroup list={LAUNDRY} name={`${defaultSuffix}laundry`} />
        <HandleError name={`${defaultSuffix}laundry`} />
      </FormRow>

      <FormRow label="Parking">
        <Grid
          container
          spacing={1}
          justifyContent="flex-start"
          alignItems="flex-start"
        >
          {PARKING.map((x, index) => (
            <Grid item xs={12} sm={3} key={index}>
              <CheckboxSingle
                key={index}
                {...x}
                name={`${defaultSuffix}${x.id}`}
              />
            </Grid>
          ))}
        </Grid>
      </FormRow>

      <FormRow label="Security">
        <CheckboxGroup list={SECURITY} name={`${defaultSuffix}safety`} />
      </FormRow>

      <FormRow label="Utilities and Services Included">
        <CheckboxGroup
          list={UTILITIES_SERVICES}
          name={`${defaultSuffix}utilities`}
        />
      </FormRow>

      <FormRow label="24 Hour Maintenance">
        <CheckboxSingle name={`${defaultSuffix}${MAINTENANCE.id}`} label="" />
      </FormRow>

      <FormRow label="Additional Information" hideDivider>
        <Textarea name={`${defaultSuffix}additionalInformationMarkdown`} />
      </FormRow>
    </>
  );
}

export default FormProperty;
